var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"document-tabs"},_vm._l((_vm.documents),function(document){return _c('DocumentTab',{key:document.id,staticClass:"document-tab",class:{ active: document.id === _vm.activeId },attrs:{"document":document},on:{"document-click":function($event){return _vm.$emit('document-click', document.id)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }